import { ListboxGroup } from './ListboxGroup';

// TODO: in v9, move styled() from ListboxGroup.jsx to here
export var StyledListboxGroup = ListboxGroup;